// @flow strict

import * as React from "react";
import CountUp from "react-countup";
import { CardHeader, Col, Row } from "reactstrap";

function StatistiquesDetail({ data }) {
  return (
    data.length > 0 && (
      <CardHeader className="p-0 border-0 border-bottom-dark bg-soft-light">
        <Row className={`g-0 text-center row-cols-sm-${data.length > 4 ? 4 : data.length}`}>
          {data.map((col, key) => {
            return (
              <Col
                xs={data.length === 1 ? 12 : 6}
                key={key}
              >
                <div className="p-3 border border-dashed border-start-0">
                  <h5 className="mb-1">
                    <CountUp
                      start={0}
                      end={col.value || 0}
                      prefix={col.prefix}
                      suffix={col.suffix}
                      duration={3}
                      separator="."
                    />
                  </h5>
                  <p className="text-muted mb-0">{col.title}</p>
                </div>
              </Col>
            );
          })}
        </Row>
      </CardHeader>
    )
  );
}

export default StatistiquesDetail;
